/**
 * Validates whether a user has the specified permissions.
 *
 * @param permissions - The permission(s) to check, can be a single string or an array of strings
 * @param userPermissions - The list of permissions the user currently has
 * @param operator - The logic operator to use for permission validation ('AND' or 'OR'), defaults to 'AND'
 * @returns A boolean indicating whether the user has the required permissions
 */
function validatePermissions(
  permissions: string | string[],
  userPermissions: string[],
  operator: 'AND' | 'OR' = 'AND',
) {
  const permissionsArray = Array.isArray(permissions) ? permissions : [permissions];
  const validationMethod = operator === 'AND' ? 'every' : 'some';

  return permissionsArray[validationMethod]((permission) => userPermissions.includes(permission));
}

export { validatePermissions };
